import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

type VisitDetailDictionary = { [contactId: number]: { [pathLowerCased: string]: VisitDetail } };

export type ShortenedUrlState = {
  visitDetailsByContactId: VisitDetailDictionary;
  visitDetailsStateByContactId: StateDictionary;
};

type State = { shortenedUrls: ShortenedUrlState };

const visitDetailsByContactIdSelector = (state: State) =>
  state.shortenedUrls.visitDetailsByContactId;
export const visitDetailsForContactIdSelector = createSelector(
  [visitDetailsByContactIdSelector, (_state: State, contactId: number) => contactId],
  (visitDetailsByContactId, contactId) => visitDetailsByContactId[contactId] ?? [],
);

const visitDetailsStateByContactIdSelector = (state: State) =>
  state.shortenedUrls.visitDetailsStateByContactId;
export const visitDetailsStateForContactIdSelector = createSelector(
  [visitDetailsStateByContactIdSelector, (_state: State, contactId: number) => contactId],
  (visitDetailsStateByContactId, contactId) => visitDetailsStateByContactId[contactId] ?? [],
);
